import { render } from "./ModalGeneral.vue?vue&type=template&id=62989b0e&scoped=true"
import script from "./ModalGeneral.vue?vue&type=script&lang=js"
export * from "./ModalGeneral.vue?vue&type=script&lang=js"

import "./ModalGeneral.vue?vue&type=style&index=0&id=62989b0e&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62989b0e"]])

export default __exports__